<template>
	<div id="page">
		
		<!-- 页头 -->
		<pagehead />
		
		<!-- 占高盒 -->
		<div class="pager">
			<!-- 个人中心盒子 -->
			<div class="mineBox df dfsb w1k2 mauto">
				<!-- 左侧内容 -->
				<mineleft />
				<!-- 右侧内容 -->
				<div class="mineBoxR f1 ml25">
					<!-- 上面卡片 -->
					<el-tabs type="border-card" class="repwd">
						<el-tab-pane label="KEY">
							<!-- 卡片内容 -->
							<template>
								<!-- 用户信息 -->
								<div class="userInfo plr10">
									
									<!-- 我的KEY -->
									<div class="userInfoList df">
										<!-- <div class="userInfoListL">我的KEY</div> -->
										<!-- <div class="userInfoListR">{{appkey}}</div> -->
										<div class="userInfoListL">我的KEY：<i class="el-icon-info c999"></i></div>
										<div class="userInfoListM">
											<el-input readonly v-model="form.appkey"></el-input>
										</div>
									</div>
									
									<!-- 我的密钥 -->
									<div class="userInfoList df">
										<div class="userInfoListL">我的密钥：<i class="el-icon-info c999"></i></div>
										<!-- <div class="userInfoListM"> -->
											<!-- <el-input :show-password="show2" v-model="form.myPwd"></el-input> -->
										<!-- </div> -->
										<div class="userInfoListR">
											 <el-button type="primary" @click="getPwd">重置</el-button>
										</div>
									</div>
									
									<div class="explain mt30 lh30 caaa f14">
										<p>“我的KEY”是开发识别码，配合开发者密码可调用数据平台的接口能力。</p>
										<p>“我的密钥”是校验数据平台开发者身份的密码,具有极高的安全性。为保障帐号安全,平台不再储存密钥,如果遗忘,请重置。</p>
									</div>
									
									<!-- 我的秘钥 -->
									<!-- <div class="userInfoList df">
										<div class="userInfoListL">我的密钥</div>
										<div class="userInfoListR c0060dd"><el-button type="text" @click="rek0ey = true">重置</el-button></div>
									</div> -->
									<!-- 列表结束 -->
								</div>
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		
		
		<!-- 页脚 -->
		<pagefoot />
		
	</div>
</template>
<script>
	// 全局变量
	var that;
	export default{
		// 页面变量
		data() {
			return {
				// 弹窗
				rekey: false,
				// 显示
				show1: true,
				show2: true,
				form: {},
			}
		},
		
		// 实例化后
		created() {
			that = this;
			
			// 获取key
			that.getKey();
			
		},
		
		// 方法集
		methods:{
			
			// 获取文字
			getPwd(){
				// 弹窗提示
				that.alert({
					title: '秘钥重置',
					value: '是否要重置秘钥？',
					// 成功
					success(rs){
						
						// 点击确定
						if(rs.confirm){
							
							// 请求接口 
							that.request({
								url: '/api/member/resetSecret',
								// 上传数据
								data:{
									// 会员id
									memberId: localStorage.getItem('memberId'),
								},
								// 调用成功
								success(rs){
									// 返回成功
									if(rs.code == 200){
										
										// 弹窗提示
										that.$alert('<p>您的秘钥已重置，新秘钥为：</p><p>' + rs.data + '</p><p>为保障账号安全，平台不再存储秘钥，请截图或复制保存，如果遗忘，请重置。</p>','密钥更新提示',{
											dangerouslyUseHTMLString: true,
										}).then((rs)=>{
											// 返回调用
										});
										
									}else{
										
										//弹窗提示用户
										that.$message.error(rs.msg);
									}
								}
							})
							
						}
					}
				})

			},
			
			// 获取key
			getKey(){
				// 请求接口 获取秘钥
				that.request({
					url: '/api/member/showKey',
					// 上传数据
					data:{
						// 会员id
						memberId: localStorage.getItem('memberId'),
					},
					// 调用成功
					success(rs){
						// 返回成功
						if(rs.code == 200){
							
							// 赋值KAY
							that.form.appkey = rs.data.appkey;
							
							// 重新赋值刷新页面
							that.form = Object.assign({},that.form);
							
						}else{
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},
			
		},
	};
</script>
<style>
/* 左侧盒子 */
.mineBoxL {
	width: 170px;
}
/* 用户头像 */
.userPhoto {
	width: 36px;
	height: 36px;
}
/* 用户等级 */
.userLevel {
	width: 46px;
	height: 18px;
}
/* 用户等级文字 */
.userLevelTxt {
	right: 3px;
	line-height: 18px;
}
/* 左盒子列表 */
.mineBoxLB ul li {
	display: flex;
	justify-content: space-between;
	padding: 15px 20px;
	text-indent: 20px;
	color: #333;
	font-size: 14px;
}
/* 左盒子列表更多箭头 */
.mineBoxLB ul li .more {
	opacity: 0;
	transition: .2s;
}
/* 左侧盒子鼠标经过 */
.mineBoxLB ul li:hover {
	color: #0066dd;
	background-color: #F6FAFF;
}
/* 左侧盒子鼠标经过更多箭头 */
.mineBoxLB ul li:hover .more {
	opacity: 1;
}
/* 左侧盒子选中样式 */
.mineBoxLB ul li.active {
	color: #0066dd;
	background-color: #F6FAFF;
}
/* 左盒子列表更多箭头 */
.mineBoxLB ul li.active .more {
	opacity: 1;
}

/* 修改密码 */
.repwd {
	height: 450px;
}

/* 用户信息列表 */
.userInfoList {
	margin-top: 12px;
	align-items: center;
}

/* 用户信息列表左 */
.repwd .userInfoListL {
	width: 100px;
	line-height: 40px;
	text-align: right;
}
/* 用户信息列表左 */
.repwd .userInfoListM {
	margin-left: 25px;
}
.repwd .userInfoListM .el-input__inner {
	width: 400px;
}
/* 用户信息列表左右 */
.userInfoListL,
.userInfoListR {
	/* color: #666; */
	font-size: 14px;
}
/* 头部选项卡 */
.mineBoxR .el-tabs__item {
	font-size: 16px;
	font-weight: bold;
	height: 60px;
	line-height: 60px;
}
/* 顶部选中样式 */
.mineBoxR .el-tabs__item.is-top.is-active {
	color: #333;
}

/* 修改密码按钮 */
.repwdBtn {
	margin-top: 50px;
	margin-left: 250px;
}
.repwdBtn .el-button.el-button--primary {
	width: 160px;
	background-color: #0060DD;
}
/* 重置秘钥 */
.el-dialog__body {
	padding: 0;
}
/* 秘钥弹窗 */
.el-dialog__wrapper.rekey .el-dialog {
	min-width: 300px !important;
	max-width: 300px !important;
}
/* 秘钥弹窗关闭X */
.el-dialog__wrapper.rekey .el-dialog__headerbtn {
	display: none;
}
/* 秘钥弹窗标题 */
.el-dialog__wrapper.rekey .el-dialog__title {
	font-weight: bold;
}
/* 提示秘钥弹窗 */
.el-message-box {
	width: auto;
}
/* 提示秘钥弹窗 */
.el-message-box p {
	padding: 0 30px;
	line-height: 40px;
}
/* 确定按钮行 */
.el-message-box__btns {
	/* text-align: center; */
}
/* 确定按钮 */
.el-message-box__btns .el-button {
	/* width: 200px; */
	/* padding: 10px 0; */
	/* font-size: 14px; */
}
</style>